import { CategoryType } from './types'

interface CategoryProps {
  category: CategoryType
}

export default function Category({ category }: CategoryProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Name:</strong>
        {category.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {category.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Description:</strong>
        {category.description?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Slug:</strong>
        {category.slug?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {category.status?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Community:</strong>
        {category.community_id?.toString()}
      </p>
    </div>
  )
}
